import { j as e, c as B } from "../../utils-BdNIfrGQ.js";
import S, { hexToHSL as H } from "../../theme/provider/ThemeProvider.mjs";
import { createElement as P, useMemo as R } from "react";
import { T as A } from "../../ThumbnailImage-CQfW_Fzc.js";
import { H as C } from "../../H2-CGvOaVnq.js";
import { u as V } from "../../index-C0pJYwuM.js";
import "../../ScrollToGrid-6uyEoyhk.js";
import { S as y } from "../../Split-CEoNwvSo.js";
import { D as a } from "../../Div-spVpsZsH.js";
import { D as v } from "../../Div.skeleton-DLnqOZrU.js";
import { F as t } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { N as I } from "../../NavLink-D9Qfouy1.js";
import { H as M } from "../../HamburgerMenu-Bi4wrZqX.js";
import { P as _, a as D } from "../../PageContext.skeleton-0lKX-xLX.js";
import { a as E } from "../../Button-CzIiGCVn.js";
import { L as F } from "../../List-L_RxfO5h.js";
import { E as O } from "../../ExternalLink-CwLUkrFF.js";
import { P as U } from "../../Paragraph-Cpgi01iq.js";
import { T as N } from "../../Text-BhLXzYEf.js";
import { c as W } from "../../index-Di82Y7n3.js";
import { H as X } from "../../Header-rsvbExbw.js";
import { B as q } from "../../BackgroundImage-BY06z4x1.js";
import G from "./components/PageBanner.mjs";
import "../../toast-DrFMmSLk.js";
import "react-dom";
import { u as J, R as $ } from "../../ResponsiveProvider-C06ERneB.js";
import { B as w } from "../../Button.skeleton-D0Onk1OP.js";
import { T as K } from "../../toaster-DencLePE.js";
import "../avatar/Avatar.mjs";
const Y = W("", {
  variants: {
    branding: {
      primary: "bg-primary text-primary-foreground",
      secondary: "bg-secondary text-secondary-foreground",
      transparent: "bg-transparent text-branded-foreground",
      inherit: "bg-inherit text-inherit"
    }
  },
  defaultVariants: {
    branding: "inherit"
  }
}), s = "https://raceroster.com", Z = (r) => {
  switch (r.split("-")[0]?.toLowerCase()) {
    case "en":
      return `${s}/legal/privacy-policy`;
    case "fr":
      return `${s}/legal/privacy-policy-fr-ca`;
    case "ja":
      return `${s}/legal/privacy-policy-ja`;
    case "es":
      return `${s}/legal/privacy-policy-es`;
    case "zh":
      return `${s}/legal/privacy-policy-hongkong`;
    case "ms":
      return `${s}/legal/privacy-policy-my`;
    default:
      return `${s}/legal/privacy-policy`;
  }
}, Q = (r) => {
  switch (r.split("-")[0]?.toLowerCase()) {
    case "en":
      return `${s}/legal/tos-for-event-registrants`;
    case "fr":
      return `${s}/legal/tos-event-registrants-fr`;
    case "ja":
      return `${s}/legal/tos-event-registrants-ja`;
    case "es":
      return `${s}/legal/tos-event-registrants-es`;
    case "zh":
      return `${s}/legal/tos-event-registrants-hongkong`;
    // TODO: When the Melayu language has a ToS page, uncomment this case
    // case 'ms':
    //   return `${RACE_ROSTER_DOMAIN}/legal/tos-event-registrants-my`;
    default:
      return `${s}/legal/tos-for-event-registrants`;
  }
}, ee = ({
  branding: r = "transparent",
  isQuebecEvent: o,
  locale: i = "en-US",
  byRaceRoster: n = "Powered by Race Roster",
  privacyLinkLabel: c,
  termsLinkLabel: g,
  copyRightLabel: h,
  additionalInfo: m,
  contactUs: x
}) => {
  const f = Z(o ? "fr-CA" : i), d = Q(o ? "fr-CA" : i), p = [
    {
      id: "privacy",
      href: f,
      children: c
    },
    {
      id: "terms",
      href: d,
      children: g
    }
  ];
  return /* @__PURE__ */ e.jsx(
    "footer",
    {
      className: B(Y({ branding: r }), "z-1 w-full pt-[48px] pb-6 px-6 md:px-7"),
      children: /* @__PURE__ */ e.jsxs(t, { gap: "7", className: "flex-col md:flex-row-reverse justify-between", children: [
        /* @__PURE__ */ e.jsxs(t, { className: "flex-col items-start md:items-end", children: [
          /* @__PURE__ */ e.jsxs(F, { direction: "horizontal", gap: "7", children: [
            p?.map((l) => /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(O, { href: l.href, target: "_blank", children: l.children }) }, l.id)),
            x && /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(
              E,
              {
                type: "button",
                variant: "link",
                size: "full",
                rounded: "none",
                onClick: x.onClick,
                children: x.label
              }
            ) }, "contact-us")
          ] }),
          m && /* @__PURE__ */ e.jsx(a, { className: "text-muted-foreground text-sm", children: /* @__PURE__ */ e.jsx(N, { children: m }) })
        ] }),
        /* @__PURE__ */ e.jsxs(a, { className: "text-sm", children: [
          /* @__PURE__ */ e.jsx(U, { fontWeight: "semibold", children: n }),
          /* @__PURE__ */ e.jsx(N, { children: h })
        ] })
      ] })
    }
  );
}, re = ({ hamburgerMenu: r }) => /* @__PURE__ */ e.jsx(a, { className: "top-0 left-0 right-0 z-2", children: /* @__PURE__ */ e.jsx(X, { background: "transparent", children: /* @__PURE__ */ e.jsx(t, { className: "items-center justify-end w-full", children: /* @__PURE__ */ e.jsx(t, { className: "ml-auto justify-end min-w-[85px] lg:min-w-fit", children: /* @__PURE__ */ e.jsx(M, { ...r }) }) }) }) }), te = ({ srcUrl: r }) => /* @__PURE__ */ e.jsx(q, { src: r, alt: "", className: "z-0" }), se = ({ children: r }) => /* @__PURE__ */ e.jsx(
  a,
  {
    className: "sticky bottom-0 bg-white text-inherit w-full py-5 px-6 z-10 shadow-[0px_-2px_8px_0px_hsla(0,0%,10%,0.071)]",
    children: r
  }
), ae = ({
  pageHeader: r,
  pageFooter: o,
  pageNavLinks: i,
  bannerProps: n,
  pageCtx: c,
  children: g,
  slots: h,
  brandedBackground: m,
  dynamicWidth: x,
  containerFooterSlot: f
}) => {
  const { callToAction: d, stickyHeaderActions: p } = h, { isMobile: l, isPortrait: u, isXL: j } = J(), k = l || u, { ref: z, inView: L } = V({
    threshold: 0,
    rootMargin: "0px",
    initialInView: !0
  }), T = x && j ? "min-w-[1024px] w-fit max-w-[95%]" : "w-full max-w-[1024px]";
  return /* @__PURE__ */ e.jsxs(t, { className: "relative flex-col min-h-screen bg-branded-background", children: [
    /* @__PURE__ */ e.jsx(re, { ...r }),
    n?.bannerImage && (n.bannerImage.desktop || n.bannerImage.mobile) && /* @__PURE__ */ e.jsx(G, { ...n }),
    /* @__PURE__ */ e.jsx(
      "main",
      {
        className: `z-1 flex flex-col flex-1 ${T} mx-auto my-2 gap-7`,
        children: /* @__PURE__ */ e.jsxs(
          a,
          {
            className: `relative rounded-[32px] shadow-lg bg-white border border-b-gray-400 ${l ? "pt-7" : "pt-9"} pb-11`,
            children: [
              !l && p && /* @__PURE__ */ e.jsx(a, { className: "sticky top-0 z-1 h-0 pointer-events-none", children: /* @__PURE__ */ e.jsx(
                a,
                {
                  "data-testid": "sticky-cta-container",
                  "data-sticky-visible": L ? "false" : "true",
                  className: "absolute inset-x-0 top-0 z-1 bg-white px-9 py-4 border-b border-b-gray-200 opacity-0 invisible pointer-events-none data-[sticky-visible=true]:opacity-100 data-[sticky-visible=true]:visible data-[sticky-visible=true]:pointer-events-auto",
                  children: /* @__PURE__ */ e.jsx(
                    y,
                    {
                      leftSlot: /* @__PURE__ */ e.jsxs(t, { className: "flex-grow flex-row items-center", gap: "4", children: [
                        c.logo && /* @__PURE__ */ e.jsx(t, { className: "bg-transparent self-start flex-shrink-0 h-fit", children: /* @__PURE__ */ e.jsx(A, { src: c.logo.src, alt: c.logo.alt, size: "xs" }) }),
                        /* @__PURE__ */ e.jsx(C, { align: "left", size: "lg", children: c.name })
                      ] }),
                      rightSlot: p && /* @__PURE__ */ e.jsx(a, { children: p }),
                      orientation: "horizontal"
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ e.jsxs(
                t,
                {
                  gap: "0 7",
                  className: `flex-col ${x ? "max-w-[1024px] mx-auto" : ""} px-7 sm:px-9 ${i?.length ? "border-b border-b-gray-200" : ""}`,
                  children: [
                    /* @__PURE__ */ e.jsx(
                      y,
                      {
                        leftSlot: /* @__PURE__ */ e.jsx(_, { ...c }),
                        rightSlot: k ? void 0 : /* @__PURE__ */ e.jsx(a, { children: d }),
                        orientation: "responsive"
                      }
                    ),
                    i?.length && /* @__PURE__ */ e.jsx("nav", { children: /* @__PURE__ */ e.jsx(t, { gap: "4", ref: z, className: "relative z-2 overflow-x-auto bg-white", children: i.map((b) => /* @__PURE__ */ P(I, { ...b, key: b.id, variant: "pageLink" }, b.children)) }) })
                  ]
                }
              ),
              /* @__PURE__ */ e.jsxs(
                t,
                {
                  "data-testid": "page-content-container",
                  gap: "7",
                  className: "flex-col pt-6 px-7 sm:pt-9 sm:px-9 [&>*]:border-b [&>*]:border-border [&>*:last-child]:border-b-0 [&>*]:pb-7 [&>*:last-child]:pb-0",
                  children: [
                    g,
                    f
                  ]
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ e.jsx(ee, { ...o }),
    m && /* @__PURE__ */ e.jsx(te, { srcUrl: m.srcUrl }),
    d && k && /* @__PURE__ */ e.jsx(se, { children: d })
  ] });
}, Ie = ({
  pageHeader: r,
  pageFooter: o,
  pageNavLinks: i,
  bannerProps: n,
  pageCtx: c,
  children: g,
  slots: h,
  brandingColors: m,
  brandedBackground: x,
  dynamicWidth: f,
  containerFooterSlot: d
}) => {
  const p = R(() => {
    if (m)
      return Object.entries(m).reduce((l, [u, j]) => (l[u] = H(j), l), {});
  }, [m]);
  return /* @__PURE__ */ e.jsx(S, { themeConfig: { brandingColors: p }, children: /* @__PURE__ */ e.jsxs($, { children: [
    /* @__PURE__ */ e.jsx(K, {}),
    /* @__PURE__ */ e.jsx(
      ae,
      {
        pageHeader: r,
        pageNavLinks: i,
        pageFooter: o,
        bannerProps: n,
        pageCtx: c,
        slots: h,
        dynamicWidth: f,
        brandedBackground: x,
        containerFooterSlot: d,
        children: g
      }
    )
  ] }) });
}, oe = () => /* @__PURE__ */ e.jsx(
  t,
  {
    className: "h-[50px] flex-row justify-end items-center px-5",
    "data-testid": "header-skeleton",
    children: /* @__PURE__ */ e.jsx(t, { className: "w-[85px] justify-end", children: /* @__PURE__ */ e.jsx(w, { grayVariant: 300, variant: "outline" }) })
  }
), ie = () => /* @__PURE__ */ e.jsx(v, { className: "h-[100px] md:h-[80px]", "data-testid": "footer-skeleton" }), Me = ({ bannerProps: r, name: o }) => {
  const i = r ? "mt-[-12px] lg:mt-[-48px]" : "mt-[80px]";
  return /* @__PURE__ */ e.jsx(S, { children: /* @__PURE__ */ e.jsx($, { children: /* @__PURE__ */ e.jsxs(t, { className: "flex-col min-h-screen bg-background", "data-testid": "layout-skeleton", children: [
    /* @__PURE__ */ e.jsx(oe, {}),
    r && /* @__PURE__ */ e.jsx(
      v,
      {
        className: "h-[200px] md:h-[500px] w-full",
        "data-testid": "banner-skeleton"
      }
    ),
    /* @__PURE__ */ e.jsx(
      t,
      {
        gap: "7",
        className: `flex-col flex-1 w-full max-w-[1024px] mx-auto ${i} overflow-scroll`,
        children: /* @__PURE__ */ e.jsxs(a, { className: "relative rounded-lg bg-white border border-b-gray-400", children: [
          /* @__PURE__ */ e.jsxs(t, { gap: "7", className: "flex-col px-7 pt-[32px] border-b border-b-gray-200", children: [
            /* @__PURE__ */ e.jsx(
              y,
              {
                leftSlot: /* @__PURE__ */ e.jsx(D, { name: o }),
                rightSlot: /* @__PURE__ */ e.jsx(w, { grayVariant: 400, size: "lg" })
              }
            ),
            /* @__PURE__ */ e.jsx("nav", { children: /* @__PURE__ */ e.jsx(t, { gap: "4", className: "overflow-x-auto", children: [{ id: 1 }, { id: 2 }, { id: 3 }].map(({ id: n }) => /* @__PURE__ */ e.jsx(w, { variant: "link" }, n)) }) })
          ] }),
          /* @__PURE__ */ e.jsx(a, { className: "px-7 py-[32px]", children: /* @__PURE__ */ e.jsx(v, { className: "h-[500px] w-full", grayVariant: 200 }) })
        ] })
      }
    ),
    /* @__PURE__ */ e.jsx(ie, {})
  ] }) }) });
};
export {
  Ie as AppLayout,
  ae as AppLayoutContent,
  Me as AppLayoutSkeleton,
  M as HamburgerMenu,
  G as PageBanner,
  ee as PageFooter,
  ie as PageFooterSkeleton,
  re as PageHeader,
  oe as PageHeaderSkeleton,
  $ as ResponsiveProvider,
  J as useResponsive
};
